<template>
    <div class="contentCard">
        <div class="screenshot"  :style="inlineBgImage(code.url)">
            <div class="overlay-card">
                <h3>{{code.title}}</h3>
            </div>
        </div>
        <div class="shortDes">
            <p v-html="code.description"></p>
        </div>
        <div class="links">
            <div class="contLinks" >
                <a :title="code.source.icoDemo.icon" v-if="code.source.url" :href="code.source.url" target="_blank">
                    <font-awesome-icon 
                        :icon="[code.source.icoDemo.type,code.source.icoDemo.icon]" 
                        :style="{color: code.source.icoDemo.color}"
                        v-tooltip='code.source.icoDemo.title'
                    />
                </a>
                <a :title="code.source.icoDemo.icon" v-if="code.source.demoUrl" :href="code.source.demoUrl" target="_blank">
                    <font-awesome-icon 
                        :icon="['fas','laptop']"   
                        :style="{color: 'black'}" 
                        v-tooltip='"Ver Demo"'
                    />
                </a>
            </div>
            <div class="contDev">
                <font-awesome-icon
                    v-for="(tool, index) in code.tools" 
                    :icon="[tool.type,tool.icon]" 
                    :key="index" 
                    :style="{color: tool.color, 'font-size': 25, padding: 10}"
                    v-tooltip='tool.title'
                />
                
            </div>
        </div>
    </div>
</template>

<script>
import utils from '../../mixins/utils';
export default {
    mixins: [utils],
    props:{
        code: {
            type: Object,
            required: true
        }
    }

}
</script>

<style>
    .contentCard{
        background: #f8f8f8;
        width: 95%;
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: 120px 200px 50px;
        grid-template-areas: "screenshot"
                    "shortDes"
                    "links";
    }
    .contentCard .screenshot{
        background-color: #e0e0e0;
        grid-area: screenshot;
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
    }
    .contentCard .screenshot .overlay-card{
        width: auto;
        height: 120px;
        background: rgba(0,0,0,0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fafafa;
    }
    .contentCard .shortDes{
        border-top: solid 1px #e0e0e0;
        padding: 10px;
        grid-area: shortDes;
    }
    .contentCard .shortDes p{
        color: #424242;
        word-wrap: break-word;
        line-height: 22px;
    }
    .contentCard .links{
        grid-area: links;
        border-top: solid 1px #34495e;
        display: grid;
        grid-template-columns: 100px 1fr;
        grid-template-rows: 1fr;
        justify-items: center;
        align-items: center;
        border-radius: 0 0 0.5em 0.5em;
    }
    .contentCard .links .contLinks{
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 10px;
        width: 100%;
        justify-items: center;
        align-items: center;
    }
    .contentCard .links .contDev{
        display: grid;
        width: 100%;
        grid-template-columns: repeat(auto-fit, minmax(30px, 1fr));
        justify-items: center;
        align-items: center;
    }
</style>